export const getter = (target, property) => {
  let value = target.default
  Object.keys(target).forEach((key) => {
    if (key.includes(property)) value = target[key]
  })
  return value
}
